var map = {
	"./da.json": [
		7178,
		178
	],
	"./en-QM.json": [
		3883,
		883
	],
	"./en.json": [
		4318,
		318
	],
	"./es.json": [
		5029,
		29
	],
	"./fr.json": [
		9533,
		533
	],
	"./it.json": [
		9816,
		816
	],
	"./mx.json": [
		8232,
		232
	],
	"./pt.json": [
		6461,
		842
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2960;
module.exports = webpackAsyncContext;